import React, { useState } from 'react'

const filters = ['All', 'Frontend', 'Backend', 'Languages', 'Databases', 'Cloud and DevOps']

// capabilityHighlights intentionally removed from UI (kept for reference)

const skills = [
  { name: 'React', category: 'Frontend', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
  { name: 'JavaScript', category: 'Frontend', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
  { name: 'Tailwind CSS', category: 'Frontend', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg' },
  { name: 'HTML5', category: 'Frontend', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
  { name: 'CSS3', category: 'Frontend', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
  { name: 'Node.js', category: 'Backend', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
  { name: 'Express', category: 'Backend', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg' },
  { name: 'Java', category: 'Languages', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg' },
  { name: 'C++', category: 'Languages', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg' },
  { name: 'Python', category: 'Languages', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
  { name: 'MongoDB', category: 'Databases', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
  { name: 'MySQL', category: 'Databases', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
  { name: 'Git', category: 'Cloud and DevOps', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg' },
  { name: 'GitHub', category: 'Cloud and DevOps', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg' },
  { name: 'Docker', category: 'Cloud and DevOps', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
  { name: 'AWS', category: 'Cloud and DevOps', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg' },
]

const Skills = () => {
  const [activeFilter, setActiveFilter] = useState('All')

  const filtered =
    activeFilter === 'All' ? skills : skills.filter((s) => s.category === activeFilter)

  return (
    <section id="skills" className="scroll-mt-16 bg-slate-50 py-6 dark:bg-slate-950 md:py-8">
      <div className="mx-auto max-w-6xl px-4">
        <div className="reveal">
          <h2 className="text-center text-3xl font-semibold tracking-tight text-slate-900 dark:text-white">
            My Tech Stack
          </h2>
          <div className="mx-auto mt-3 h-1 w-12 rounded bg-primary" />
          <p className="mx-auto mt-4 max-w-2xl text-center text-slate-600 dark:text-slate-400">
            A practical stack for designing, building, connecting, and deploying modern web applications.
          </p>
        </div>

        {/* capabilityHighlights removed to simplify the skills page */}

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActiveFilter(f)}
              className={`rounded-full px-4 py-1.5 text-sm transition-colors ${
                activeFilter === f
                  ? 'bg-primary text-white'
                  : 'border border-slate-200 bg-slate-50 text-slate-600 hover:border-primary hover:text-primary dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4">
          {filtered.map((skill) => (
            <div
              key={skill.name}
              className="group flex flex-col items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 p-4 hover:border-primary/40 dark:border-slate-700 dark:bg-slate-800/50"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-white p-2 shadow-sm dark:bg-slate-800">
                <img src={skill.icon} alt="" className="h-8 w-8 object-contain" loading="lazy" />
              </div>
              <span className="text-sm font-medium text-slate-700 dark:text-slate-200">{skill.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Skills
